import React from "react";

const TenderDetailsSkeleton: React.FC = () => (
  <div style={{
    filter: 'blur(4px) grayscale(0.5)',
    pointerEvents: 'none',
    userSelect: 'none',
    minHeight: '60vh',
    background: 'rgba(240,240,240,0.9)',
    borderRadius: '1rem',
    padding: '2rem',
    margin: '2rem auto',
    maxWidth: 900,
    boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
  }}>
    <div style={{ height: 32, width: '40%', background: '#ddd', borderRadius: 8, marginBottom: 24 }} />
    <div style={{ height: 18, width: '60%', background: '#eee', borderRadius: 6, marginBottom: 18 }} />
    <div style={{ height: 18, width: '80%', background: '#eee', borderRadius: 6, marginBottom: 18 }} />
    <div style={{ height: 18, width: '55%', background: '#eee', borderRadius: 6, marginBottom: 18 }} />
    <div style={{ height: 180, width: '100%', background: '#e0e0e0', borderRadius: 12, marginBottom: 24 }} />
    <div style={{ height: 18, width: '70%', background: '#eee', borderRadius: 6, marginBottom: 18 }} />
    <div style={{ height: 18, width: '50%', background: '#eee', borderRadius: 6, marginBottom: 18 }} />
    <div style={{ height: 18, width: '90%', background: '#eee', borderRadius: 6, marginBottom: 18 }} />
  </div>
);

export default TenderDetailsSkeleton;
